import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { FindingClassType, FindingType } from '../../types';
import { FindingGroup } from '../../findingDetails/findingDetails/types';
import EasmRelatedFindingsController from '../controller/EasmRelatedFindingsController';

export default class EasmRelatedFindingsWebComponent extends BaseWebComponentElement {
  public controller: EasmRelatedFindingsController | null;
  private _findingId: string;
  private _findingClassType: FindingClassType;
  private _findingGroups: FindingGroup[];
  private _findingTypeGroupToFocusOn: FindingType | null = null;

  public constructor() {
    super();

    this.initialSetup({
      controllerConstructor: EasmRelatedFindingsController,
    });
  }

  public get findingId(): string {
    return this._findingId;
  }

  public set findingId(findingId: string) {
    this._findingId = findingId;
  }

  public get findingClassType(): FindingClassType {
    return this._findingClassType;
  }

  public set findingClassType(findingClassType: FindingClassType) {
    this._findingClassType = findingClassType;
  }

  public get findingGroups(): FindingGroup[] {
    return this._findingGroups;
  }

  public set findingGroups(findingGroups: FindingGroup[]) {
    this._findingGroups = findingGroups;
  }

  public get findingGroupTypeToFocusOn(): FindingType | null {
    return this._findingTypeGroupToFocusOn;
  }

  public set findingGroupTypeToFocusOn(findingGroupTypeToFocusOn: FindingType | null) {
    this._findingTypeGroupToFocusOn = findingGroupTypeToFocusOn;
  }

  /**
   * @throws {Error}
   */
  public async start(): Promise<void> {
    if ([typeof this._findingId, typeof this._findingClassType, typeof this._findingGroups].includes('undefined')) {
      throw new Error(
        'The EASM related findings components needs a finding id, finding class type and finding groups in order to start.'
      );
    }

    await super.start();
  }
}
